// extracted by mini-css-extract-plugin
module.exports = {"error":"pending_error_3tK7T","table":"pending_table_OKhdZ","textDivider":"pending_textDivider_8aeeI","textDividerContent":"pending_textDividerContent_2pPLi"};